var _rect, _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9.14286,
    fill: "#F4F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7137 23.144C11.3348 23.144 10.9715 22.9935 10.7036 22.7256C10.4357 22.4577 10.2852 22.0943 10.2852 21.7154V10.2869C10.2852 9.90797 10.4357 9.54461 10.7036 9.2767C10.9715 9.00879 11.3348 8.85828 11.7137 8.85828H17.428C17.6541 8.85791 17.8781 8.90228 18.087 8.98883C18.2959 9.07538 18.4856 9.20239 18.6452 9.36256L21.208 11.9254C21.3686 12.0851 21.496 12.275 21.5828 12.4841C21.6696 12.6933 21.7141 12.9175 21.7137 13.144V21.7154C21.7137 22.0943 21.5632 22.4577 21.2953 22.7256C21.0274 22.9935 20.664 23.144 20.2852 23.144H11.7137Z",
    stroke: "#7C7AFF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4277 8.85828V12.4297C17.4277 12.6191 17.503 12.8008 17.6369 12.9348C17.7709 13.0687 17.9526 13.144 18.142 13.144H21.7134",
    stroke: "#7C7AFF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 13.8583H13.1426",
    stroke: "#7C7AFF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 16.7157H13.1426",
    stroke: "#7C7AFF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 19.5731H13.1426",
    stroke: "#7C7AFF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.fbda91b3f7850d49975e25403e34c540.svg";
export { ForwardRef as ReactComponent };